import { render, staticRenderFns } from "./pointDetail.vue?vue&type=template&id=6ee5d570&scoped=true&"
import script from "./pointDetail.vue?vue&type=script&lang=js&"
export * from "./pointDetail.vue?vue&type=script&lang=js&"
import style0 from "./pointDetail.vue?vue&type=style&index=0&id=6ee5d570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee5d570",
  null
  
)

export default component.exports